import About from "../components/About";
import FeatureWorks from "../components/FeatureWorks";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Newsletter from "../components/Newsletter";
import ParticlesBackground from "../components/ParticlesBackground";
import Offers from "../components/Services/Offers";
import Testimonials from "../components/Testimonials";

const Home = () => {
  return (
    <div className="text-white flex flex-col font-inter">
      <Hero />
      <div className="font-inter text-white overflow-x-hidden flex flex-col">
        <FeatureWorks />
        <About />
      </div>
      <div className="px-8 font-inter text-white overflow-x-hidden xl:px-20 2xl:px-60 flex flex-col"></div>
      <Offers />
      <div className="px-8 py-10 font-inter text-white overflow-x-hidden xl:px-20 2xl:px-60 flex flex-col">
        <Testimonials />
        <div className="-z-10">
          <ParticlesBackground id="particles" />
        </div>
        <Newsletter />
      </div>
      <Footer link="/" />
    </div>
  );
};

export default Home;
